import { Injectable } from '@angular/core';

import { forkJoin, of } from 'rxjs';
import { BalanceService } from './balance.service';
import { config } from '../../shared/config';
import { catchError, mapTo } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/core/logging.service';

@Injectable({ providedIn: 'root' })
export class BalanceResolver {
  constructor(private balanceService: BalanceService, private logService: LoggingService) {}

  resolve() {
    let ecash$ = this.balanceService.fetchBalance(config.purseConfig.combined);
    let points$ = this.balanceService.fetchBalance(config.purseConfig.virtualLoyalty);
    return forkJoin([ecash$, points$]).pipe(
      mapTo(null),
      catchError((error) => {
        this.logService.error('[Balance Resolver] Request Error', error.error.Message);
        return of(null);
      })
    );
  }
}
